import React, { useEffect, useRef, useState } from 'react';
import './Home.css'
import './MyFontsWebfontsKit.css';
import { ModalController, UserManager } from '../Managers/exports';
import { Parallax, Background } from 'react-parallax';
import { Fade } from '@material-ui/core';
import { useWindowDimensions } from 'react-native';
import { Episodes } from '../Components/EpisodeTile/Episodes';
import { NavBar } from '../Components/NavBar /NavBar';


import { Popover } from '@material-ui/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs'
import { AUTHENTICATION_STATUS } from '../Constants';
import { VideoPlayer } from '../Components/VideoPlayer/VideoPlayer';

export const Home = () => {
    const onSecureSpot = () => {
        ModalController.open()
    }

    const watchRef = useRef()
    const learnMoreRef = useRef()

    const [loggedIn, setLoggedIn] = useState(false)

    const leaving = new Subject()
    useEffect(() => {
        UserManager.getAuthenticationStatus()
        .pipe(takeUntil(leaving))
        .subscribe(status => {
            switch(status){
                case AUTHENTICATION_STATUS.authenticated : setLoggedIn(true); break
                default: setLoggedIn(false)
            }
        })

        return () => leaving.next()
    }, [])

    const gotoWatch = () => watchRef.current.scrollIntoView()
    const gotoLearnMore = () => learnMoreRef.current.scrollIntoView()


    let ismobile;
    const dems = useWindowDimensions()
    if(dems.height > dems.width) {
        ismobile = true
    }
    const paraheight = dems.width > dems.height ? Math.max(dems.width / 1.5, 300) : dems.width


    const mobileReigster = (value) => {
        const scale = Math.min(0.4 + value, 1)
        return(
            <div className="mobile desktop-hide" >
                <button id="registerNow" onClick={onSecureSpot}>{loggedIn ? "You're Registered!" : "Register Now"}</button>
                <div className="mobile-container desktop-hide" style={{
                }}>
                    
                    <p>Learn how prayer is changing the lives of people around the world during this exciting five-part series.</p>
                    <p><span>Registration is free!</span> Sign up for Connect to receive event updates and exclusive giveaways, including Bibles, and e-books!</p>
                    <h2 className="stretch">At Connect, we'll share how to:</h2>
                    <ul>
                        
                        <li>Pray more effective prayers</li>
                        <li>Listen for God's answers to prayer</li>
                        <li>Understand better what to pray for</li>
                        <li>Line prayers up with God's will</li>
                        <li>Receive God's answers to prayers</li>
                    </ul>
                </div>
            </div>
        )
    }

    const desktopInfo = () => {


        return(
            <div className="desktop-info">
                <p>Learn how prayer is changing the lives of people around the world during this exciting five-part series</p>
                    <h2 className="stretch">At Connect, we'll share how to:</h2>
                    <ul>
                        <li>Pray more effective prayers</li>
                        <li>Listen for God's answers to prayer</li>
                        <li>Understand better what to pray for</li>
                        <li>Line prayers up with God's will</li>
                        <li>Receive God's answers to prayers</li>
                    </ul>
            </div>
        )
    }
    
    return (
        <>
        <section role={"navigation"}>
            <NavBar 
                gotoWatch={gotoWatch}
                gotoLearnMore={gotoLearnMore}
                onSecureSpot={onSecureSpot}
            />
        </section>
        <header>
            <Fade in={true} timeout={300}>
                <div className="header">
                    <h1 style={{fontSize: "0em"}}>Connect</h1>
                    <img src={require("../Images/connect.png")}  alt="None"/>
                    <div className="header-present">
                        <span>Presented by</span>
                        <img src={require("../Assets/long_logo.svg")} alt="logo"/>
                    </div>
                    <div className="header-date isidora">
                        {/* <h2>August 9, 2021</h2> */}
                    </div>
                    
                    <h3 className="mobile-hide">A powerful, five-part series on effective prayer</h3>
                    <h4 className="mobile-hide"><span>Registration is free!</span> Sign up for Connect to receive event updates<br/>
                    and exclusive giveaways and e-books!</h4>
                    <div className="header-button-translate">
                    <button className="mobile-hide" onClick={onSecureSpot}>{loggedIn ? "You're Registered!" : "Register Now"}</button>
                    </div>
                </div>
            </Fade>
        </header>
        
        <section  role={"main"}>
            <Fade in={true} timeout={300}>
                <Parallax 
                    contentClassName="paralax-content"
                    style={{height: ismobile ? paraheight * .50 : 600}}
                    bgStyle={{opacity: 0.9}}
                    bgImageStyle={{ objectFit: 'cover', width: '100vw', opacity: "0.95"}}
                    bgImage={require("../Images/pray.jpeg")}
                    bgImageAlt="Parying people" 
                    strength={ismobile ? 100 : 300}>
                        <h3 ><i>Get more out of prayer TODAY!</i></h3>
                </Parallax>
                
            </Fade>


        <div ref={learnMoreRef} style={{transform: "translateY(-100px)"}}></div>

            <Parallax
                strength={500}
                renderLayer={mobileReigster}
            >
            </Parallax>
            

        <div class="info-outer-container" >

                <div className="info-container">
                    <img src={require("../Assets/heart.svg")} alt="heart" />
                    {desktopInfo()}
                </div>
                <div className="info-video-container">
                    <VideoPlayer />
                    {/* <img src={require("../Assets/play_button.svg")} alt="video play" /> */}
                    
                </div>


        </div>

        <div ref={watchRef}></div>       

        <div className="watch-outer-container">
      
                <h2 >Where to watch:</h2>
                <h3>Watch Connect archives on YouTube or Facebook</h3>
                <div className="watch-list-icons">
                    <a href="https://itiswritten.tv/" target="_blank"><img  className="watch-2" src={require("../Assets/watch_icons/iiwtvlogo.svg")} alt="iiw-logo"/></a>
                    <a href=" https://www.youtube.com/itiswritten" target="_blank"><img  className="watch-2" src={require("../Assets/watch_icons/youtube.svg")} alt="youtube"/></a>
                    <a href="https://www.facebook.com/itiswritten/" target="_blank"><img  className="watch-2" src={require("../Assets/watch_icons/facebook.svg")} alt="facebook"/></a>
                </div>
                <h3>Find It Is Written TV on these platforms:</h3>
                <div className="watch-list-icons" style={{border: 'none', marginBottom: 20}}>
                    <img  className="watch-2" src={require("../Assets/watch_icons/android.svg")} alt="android"/>
                    <img  className="watch-2" src={require("../Assets/watch_icons/appletv.svg")} alt="appletv"/>
                    <img  className="watch-2" src={require("../Assets/watch_icons/firetv.svg")} alt="firetv"/>
                    <img  className="watch-2" src={require("../Assets/watch_icons/roku.svg")} alt="roku"/>
                </div>

                <Episodes />
     

        </div>

        <div className="presenters-outer-container">

                <span className="presenter-head-title">Connect Presenter</span>
                <div className="presenters-container">
                        <div className="mobile-wide">
                        <Presenter 
                            name="John Bradshaw"
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center',
                              }}
                              transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center',
                              }}
                            title="Host John Bradshaw is the president of It Is Written, an international Christian media ministry based in Collegedale, Tennessee. He has held evangelistic series on six continents and recorded television programs in thirty countries."
                            src={require("../Assets/Presenters/john.png")}
                        />
                        </div>
                
                </div>

        </div>
                </section>


        <footer>
            <div className="footer">
                <p>Copyright © 2021, It Is Written, Inc. All rights reserved. </p>
            </div>
        </footer>
        </> 
    )
}



const Presenter = props => {
    const {src, name, title, anchorOrigin, transformOrigin} = props
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
  
    const handleClose = () => {
      setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? `popover-${name}` : undefined;

    return(
        <Fade in={true} timeout={500}>
            <div className="presenter">
                <div>
                    <img src={src} alt={name} />
                    <button className="presenter-button" onClick={handleClick}></button>
                    <Popover
                        id={id}
                        open={open}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                        anchorOrigin={anchorOrigin}
                        transformOrigin={transformOrigin}
                    >
                       <div className="presenter-popover">
                           <h6 >{title}</h6>
                        </div> 
                    </Popover>
                </div>
                
                <span className="presenter-name"style={{fontWeight: 'bold'}} onClick={handleClick}>{name}</span>

                <div className="presenter-bios">
                    <span className="presenter-title">{title}</span>
                </div>

                
            </div>
        </Fade>
    )
}